import { useQuery } from '@tanstack/react-query';
import { storageApi } from '../api';
import type { StorageProject, ApiResponse } from '../types';
export interface StorageProjectsParams {
  country?: string;
  status?: string;
  min_capacity?: number;
  max_capacity?: number;
  start_date?: string;
  end_date?: string;
}
export interface StorageStatisticsParams {
  group_by?: 'country' | 'year';
}
export function useStorageProjects(params?: StorageProjectsParams) {
  return useQuery({
    queryKey: ['storage', 'projects', params],
    queryFn: () => storageApi.getStorageProjects(params),
    staleTime: 10 * 60 * 1000, 
  });
}
export function useStorageProject(id: string) {
  return useQuery({
    queryKey: ['storage', 'project', id],
    queryFn: () => storageApi.getStorageProject(id),
    enabled: !!id,
    staleTime: 10 * 60 * 1000,
  });
}
export function useStorageStatistics(params?: StorageStatisticsParams) {
  return useQuery({
    queryKey: ['storage', 'statistics', params],
    queryFn: () => storageApi.getStorageStatistics(params),
    staleTime: 10 * 60 * 1000,
  });
}
